import {
    ADD_TOKEN,
    ADD_ID,
    ADD_LANG,
    ADD_CURR,
    ADD_UNIT,
    ADD_PKUIDLIST,
    ADD_IDARTICLE,
    ADD_GGTOKEN,
    ADD_EMAIL,
    ADD_PKUIDSUB,
    ADD_STRIPETOKEN,
    ADD_NAME,
    ADD_MODAL,
    ADD_USERNAME,
    ADD_REGISTER,
    ADD_LOGIN,
    ADD_RENAME,
    ADD_RESET,
    ADD_STRIPE_POPUP,
    ADD_CONTACT_INFO
} from '../../constants/AppConstants'

export const addToken = token => {
    return {
        type: ADD_TOKEN,
        payload: {
            token
        }
    }
}

export const addReset = reset =>{
    return {
        type: ADD_RESET,
        payload: {
            reset
        }
    }
}
export const addStripePopup = stripe =>{
    return {
        type: ADD_STRIPE_POPUP,
        payload: {
            stripe
        }
    }
}

export const addModal = modal => {
    return {
        type: ADD_MODAL,
        payload: {
            modal
        }
    }
}

export const addLogin = login => {
    return {
        type: ADD_LOGIN,
        payload: {
            login
        }
    }
}

export const addRegister = register => {
    return {
        type: ADD_REGISTER,
        payload: {
            register
        }
    }
}

export const addRename = rename => {
    return {
        type: ADD_RENAME,
        payload: {
            rename
        }
    }
}

export const addId = id => {
    return {
        type: ADD_ID,
        payload: {
            id
        }
    }
}

export const addLanguage = lang => {
    return {
        type: ADD_LANG,
        payload: {
            lang
        }
    }
}

export const addUnit = unit => {
    return {
        type: ADD_UNIT,
        payload: {
            unit
        }
    }
}

export const addCurrency = curr => {
    return {
        type: ADD_CURR,
        payload: {
            curr
        }
    }
}

export const addPkuidlist = pkuidlist => {
    return {
        type: ADD_PKUIDLIST,
        payload: {
            pkuidlist
        }
    }
}

export const addIdArticle = idarticle => {
    return {
        type: ADD_IDARTICLE,
        payload: {
            idarticle
        }
    }
}

export const addGgToken = tokengg => {
    return {
        type: ADD_GGTOKEN,
        payload: {
            tokengg
        }
    }
}

export const addEmail = email => {
    return {
        type: ADD_EMAIL,
        payload: {
            email
        }
    }
}

export const addPkuidsub = pkuidsub => {
    return {
        type: ADD_PKUIDSUB,
        payload: {
            pkuidsub
        }
    }
}

export const addStripeToken = stripe_token => {
    return {
        type: ADD_STRIPETOKEN,
        payload: {
            stripe_token
        }
    }
}

export const addName = name => {
    return {
        type: ADD_NAME,
        payload: {
            name
        }
    }
}

export const addUserName = name => {
    return {
        type: ADD_USERNAME,
        payload: {
            name
        }
    }
}

export const addContactInfo = contactInfo => {
    return {
        type: ADD_CONTACT_INFO,
        payload : {
            contactInfo
        }
    }
}




// WEBPACK FOOTER //
// ./src/redux/actions/AppAction.js